<template>
    <el-row>
      <el-col :span="24">

        <table class="el-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Ways</th>
              <th>Sites</th>
              <th>Percent</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(s, i) in sharing" :key="i">
              <td>{{formatInteger(i+1)}}</td>
              <td> <org-badge :short-name="s.sharer" :color="s.colourCode" /></td>
              <td><b :class="colorWays(s.ways)">{{formatInteger(s.ways)}}</b></td>
              <td><b class="text-black">{{formatInteger(s.sites)}}</b></td>
              <td><i>{{formatNumber(s.percent, 2)}}%</i></td>
              <br />
            </tr>
          </tbody>
        </table>
      </el-col>
  </el-row>

</template>


<script>

import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {

  mixins: [PostMixins, NumberMixins],

  methods: {
    sharingData (data) {
      this.sharing = data
    },

    colorWays (ways) {

      ways = Number(ways)

      switch (ways) {
        case 7: return 'text-primary'
        case 6: return 'text-success'
        case 5: return 'text-success'
        case 4: return 'text-black'
        case 3: return 'text-black'
        case 2: return 'text-warning'
        case 1: return 'text-danger'
        default: return 'text-info'
      }
    }
  },

  data () {
    return {
      sharing: []
    }
  },

  created () {
    this.fetchData('report/sharing/analysis', this.sharingData, 'Sharer Ways Report')
  }

}
</script>
